interface IconProps {
  height: number;
}

export default function TokensStudioIcon({ height }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      fill="none"
      viewBox="0 0 61 62"
    >
      <path
        fill="#151515"
        fillRule="evenodd"
        d="M0 31.384C0 17.007 0 9.818 4.467 5.351 8.933.884 16.122.884 30.5.884c14.378 0 21.567 0 26.033 4.467C61 9.818 61 17.007 61 31.384c0 14.378 0 21.567-4.467 26.034-4.466 4.466-11.655 4.466-26.033 4.466-14.378 0-21.567 0-26.033-4.466C0 52.95 0 45.762 0 31.384zm18.963-1.525c-5.429-.053-9.813-4.47-9.813-9.912 0-5.475 4.438-9.913 9.912-9.913 5.44 0 9.858 4.383 9.912 9.81l.001.074v5.015a4.927 4.927 0 01-4.927 4.926H18.963zm32.887-7.625a9.15 9.15 0 01-9.091 9.15h-4.692a4.516 4.516 0 01-4.517-4.516v-4.692c0-.047 0-.093.002-.14a9.15 9.15 0 0118.298.198zM30.654 44.182l-.002.165a8.388 8.388 0 108.222-8.386 4.75 4.75 0 00-.12-.002h-3.623a4.48 4.48 0 00-4.479 4.48v3.623l.002.12zm-4.576-2.123c0-.118-.003-.236-.009-.353.006-.089.009-.178.009-.268v-2.57a4.434 4.434 0 00-4.435-4.434h-2.569c-.09 0-.18.003-.269.008a7.625 7.625 0 107.272 7.617z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

TokensStudioIcon.defaultProps = {
  height: 24,
};
